import Vue from "vue";
import axios from "axios";
import router from "./../router/user";
import globalVar from "./../Config/config";
const userAxios = axios.create();
var API_URL = globalVar.apiUrl;

userAxios.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem("userLoginToken");
    if (token != null) {
      request.headers.common["Authorization"] = `Bearer ${token}`;
      request.headers.common["Content-Type"] = "application/json";
    }
    return request;
  },

  function (error) {
    if (error.response.status === 401) {

      // if you ever get an unauthorized, logout the user
      // localStorage.removeItem("userLoginToken");
      // localStorage.removeItem("userDetails");
      router.push({ name: "user_login" });
      // you can also redirect to /login if needed !
    }
  }
);

userAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status == 401) {
      localStorage.removeItem("userLoginToken");
      localStorage.removeItem("userDetails");
      router.push({ name: "user_login" });
    }
    return Promise.reject(error);
  }
);

let config = {
  headers: {
    "content-type": "multipart/form-data",
  },
};

const userAPI = {
  getUsersForResources(cb, errorCB) {
    userAxios
      .get(API_URL + "getUsersForResources")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  awardsforDC(cb, errorCB) {
    userAxios
      .get(API_URL + "awardsforDC")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getResourcesVendors(cb, errorCB) {
    userAxios
      .get(API_URL + "getResourcesVendors")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getResourcesDoc(cb, errorCB) {
    userAxios
      .get(API_URL + "getResourcesDoc")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  awardsforCA(cb, errorCB) {
    userAxios
      .get(API_URL + "awardsforCA")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  sendEmail(req, cb, errorCB) {
    userAxios
      .post(API_URL + "sendEmail", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  weeklyReport(req, cb, errorCB) {
    userAxios
      .post(API_URL + "weeklyReport", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getMonthlyFocusData(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getMonthlyFocusData", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  dailyReport(req, cb, errorCB) {
    userAxios
      .post(API_URL + "dailyReport", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getReportFocusData(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getReportFocusData", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUserFocusesById(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getUserFocusesById", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getReportData(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getReportData", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getQuarter(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getQuarter", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  addEditQuarterGoal(req, cb, errorCB) {
    userAxios
      .post(API_URL + "addEditQuarterGoal", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  addEditEvent(req, cb, errorCB) {
    userAxios
      .post(API_URL + "addEditEvent", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getRevFocusDailyResult(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getRevFocusDailyResult", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getInputdailyResult(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getInputdailyResult", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getEvents(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getEvents", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getReportDataForPDC(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getReportDataForPDC", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getReportDataForCA(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getReportDataForCA", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  assignFocuses(req, cb, errorCB) {
    userAxios
      .post(API_URL + "assignFocuses", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  allMembersResult(req, cb, errorCB) {
    userAxios
      .post(API_URL + "allMembersResult", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  allMembersResultUpdate(req, cb, errorCB) {
    userAxios
      .post(API_URL + "allMembersResultUpdate", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },

  getusersfocus(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getusersfocus", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },

  getFocusesWithUser(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getFocusesWithUser", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  deleteAssignFocus(req, cb, errorCB) {
    userAxios
      .post(API_URL + "deleteAssignFocus", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getMonthlyAmount(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getMonthlyAmount", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getSpecialLimitedAmount(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getSpecialLimitedAmount", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUserinfo(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getUserinfo", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUserInfoForHeader(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getUserInfoForHeader", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUserProfileInfo(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getUserProfileInfo", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  saveBillingInfo(req, cb, errorCB) {
    userAxios
      .post(API_URL + "saveBillingInfo", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getMembershipsInfoByID(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getMembershipsInfoByID", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getBillingInfoByUserID(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getBillingInfoByUserID", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getPractice(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getPractice", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getCurrentUserID(cb, errorCB) {
    userAxios
      .get(API_URL + "getuser")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getCalendlyEvent(cb, errorCB) {
    userAxios
      .get(API_URL + "getCalendlyEvent")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  // updateUserProfileInfo(req,cb, errorCB) {
  //   userAxios
  //     .post(API_URL + "updateUserProfileInfo",req,config)
  //     .then((resp) => {
  //       cb(resp);
  //     })
  //     .catch((err) => {
  //       errorCB(err);
  //     });
  // },
  getPracticeById(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getPracticeById", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  updatePractice(req, cb, errorCB) {
    userAxios
      .post(API_URL + "updatePractice", req, config)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUsersDashboard(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getUsersDashboard", req, config)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  addClientFromDashboard(req, cb, errorCB) {
    userAxios
      .post(API_URL + "addClientFromDashboard", req, config)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  editUserFromDashboard(req, cb, errorCB) {
    userAxios
      .post(API_URL + "editUserFromDashboard", req, config)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  recoverUser(req, cb, errorCB) {
    userAxios
      .post(API_URL + "recoverUser", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  removeUser(req, cb, errorCB) {
    userAxios
      .post(API_URL + "removeUser", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  updateMessage(req, cb, errorCB) {
    userAxios
      .post(API_URL + "UpdateMessage", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getGraphData(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getGraphData", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getChartData(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getChartData", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUsersListByPractice(req, cb, errorCB) {
    userAxios
      .post(API_URL + "getUsersListByPractice", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  materialUserDashboard(cb, errorCB) {
    userAxios
      .get(API_URL + "materialUserDashboard")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getStates(cb, errorCB) {
    userAxios
      .get(API_URL + "getStates")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAllFoucs(cb, errorCB) {
    userAxios
      .get(API_URL + "getAllFoucs")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getMessage(cb, errorCB) {
    userAxios
      .get(API_URL + "getMessage")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAllSkills(cb, errorCB) {
    userAxios
      .get(API_URL + "getAllSkills")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getWebinarSchedule(cb, errorCB) {
    userAxios
      .get(API_URL + "getWebinarSchedule")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getNextModule(cb, errorCB) {
    userAxios
      .get(API_URL + "getNextModule")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getcalanderlydata(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getcalanderlydata", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getMaterialBySkill(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getMaterialBySkill", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUsersByPractice(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getUsersByPractice", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  userRegisterForSeminar(params, cb, errorCB) {
    userAxios
      .post(API_URL + "userRegisterForSeminar", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getComingSeminars(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getComingSeminars", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getSeminarScheduleByModuleID(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getSeminarScheduleByModuleID", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getWebinarArchiveByModuleID(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getWebinarArchiveByModuleID", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  documentsVideosWithWeekByModule(params, cb, errorCB) {
    userAxios
      .post(API_URL + "documentsVideosWithWeekByModule", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  downloadPdf(params, cb, errorCB) {
    console.log("params", params)
    userAxios
      .post(API_URL + "downloadPdf", params, {
        responseType: 'blob',
      })
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },

  getModuleById(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getModuleById", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAllModules(cb, errorCB) {
    userAxios
      .get(API_URL + "getAllModules")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUpdatedNextModule(cb, errorCB) {
    userAxios
      .get(API_URL + "getUpdatedNextModule")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getCurrentModule(cb, errorCB) {
    userAxios
      .get(API_URL + "getCurrentModule")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getScheduleVideos(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getScheduleVideos", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getScheduleDocs(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getScheduleDocs", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  updateUserProfileInfo(req, cb, errorCB) {
    userAxios
      .post(API_URL + "updateUserProfileInfo", req, config)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getCurrentweekByModule(params, cb, errorCB) {
    userAxios
      .post(API_URL + "getCurrentweekByModule", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  saveOptInData(params, cb, errorCB) {
    userAxios
      .post(API_URL + "saveOptInData", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  checkOptStatusUserByEmail(params, cb, errorCB) {
    userAxios
      .post(API_URL + "checkOptStatusUserByEmail", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getWebContent(cb, errorCB) {
    userAxios
      .get(API_URL + "getWebContent")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  userLogin(params, cb, errorCB) {
    userAxios
      .post(API_URL + "userLogin", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  forgetuserpassword(params, cb, errorCB) {
    userAxios
      .post(API_URL + "forgetuserpassword", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  userLogout(cb, errorCB) {
    userAxios
      .post(API_URL + "userLogout", {})
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  UpdatePracticeAccount(req, cb, errorCB) {
    userAxios
      .post(API_URL + "UpdatePracticeAccount", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  createAccount(req, cb, errorCB) {
    userAxios
      .post(API_URL + "create-account", req)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
};

export default userAPI;
